import { Box, Stack, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import StyledTableRow from '../shared/components/styledTableRow';
import StyledTableCell from '../shared/components/styledTableCell';
import { GetDayJSValueFromUTCDate } from '../utils/extensions/functionEx';
import { DATE_DISPLAY_FORMAT } from '../startups/apiConfig';

const ServiceBookingReminder = (props) => {

    const { dbNurseBookings } = props;

    return (
        <Box sx={{ bgcolor: '#cfe8fc', padding: '8px, 0' }}>
            <Stack spacing={0}>
                <TableContainer component={Paper} sx={{ maxHeight: '79vh', borderRadius: '0' }}>
                    <Table stickyHeader sx={{ minWidth: 700, width: '1980px', overflowX: 'auto' }}>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell sx={{ width: '150px' }}>Booking Date</StyledTableCell>
                                <StyledTableCell sx={{ width: '200px' }}>Duty</StyledTableCell>
                                <StyledTableCell sx={{ width: '125px' }}>Duty Days</StyledTableCell>
                                <StyledTableCell sx={{ width: '150px' }}>Booked Date</StyledTableCell>
                                <StyledTableCell>Patient Name</StyledTableCell>
                                <StyledTableCell sx={{ width: '250px' }}>Place</StyledTableCell>
                                <StyledTableCell sx={{ width: '150px' }}>Phone No</StyledTableCell>
                                <StyledTableCell sx={{ width: '300px' }}>Nurse Name</StyledTableCell>
                                <StyledTableCell sx={{ width: '300px' }}>Nurse Phone No</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dbNurseBookings.map((row) => (
                                <StyledTableRow key={row.id.toString()}>
                                    <StyledTableCell>
                                        {GetDayJSValueFromUTCDate(row.booking_date).format(DATE_DISPLAY_FORMAT)}
                                    </StyledTableCell>
                                    <StyledTableCell>{row.service_type_name}</StyledTableCell>
                                    <StyledTableCell>{row.duty_days}</StyledTableCell>
                                    <StyledTableCell>{GetDayJSValueFromUTCDate(row.booked_date).format(DATE_DISPLAY_FORMAT)}</StyledTableCell>
                                    <StyledTableCell>{row.patient_name}</StyledTableCell>
                                    <StyledTableCell>{row.place}</StyledTableCell>
                                    <StyledTableCell>{row.phone_no}</StyledTableCell>
                                    <StyledTableCell>{row.nurse_name}</StyledTableCell>
                                    <StyledTableCell>{row.nurse_phone}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Stack>
        </Box>
    );
}
export default ServiceBookingReminder;